export const CHUNK_ERROR_PATTERNS = [
    /loading chunk \d+ failed/i,
    /loading css chunk \d+ failed/i,
    /failed to fetch dynamically imported module/i,
    /unable to preload css/i,
];
